import httpService from "./httpService";

export default {

  findByCode(code) {
    return httpService.get("shortLink/findByCode", {params: {code: code}});
  },
}



// WEBPACK FOOTER //
// ./src/services/shortLinkService.js